import React, { useState } from "react";
import PlacesAutocomplete from "utils/PlacesAutocomplete/PlacesAutocomplete";
import Button from "SanityComponents/GroupFormLp/Button";
import CheckBox from "ui/CheckBox";
import CustomInput from "ui/CustomInput/Input";
import style from "./style.module.css";
import { divide } from "lodash";
import useTranslation from "next-translate/useTranslation";
import getRPCQfromCoords from "utils/getRPCQfromCoords";
import { norm } from "components/v2/Listings/ListingsRouterUrlHelper";
import getUrlParams from "utils/PlacesAutocomplete/getUrlParams";

interface propsType {
  title: string;
  subTitle: string;
  SearchBarLpAnnonces?: any;
  slug?: any;
}

const bienImmo = [
  "Maison",
  "Riad",
  "Commerce",
  "Local Industriel",
  "Bureau",
  "Terrain",
];

function index(props: propsType) {
  const [showPlus, setShowPlus] = useState(false);
  const [checked, setChecked] = useState([]);
  const [prixMax, setPrixMax] = useState(0);

  const { t, lang } = useTranslation("newLp");

  const [geoCoding, setGeocoding] = useState({
    lat: "",
    lng: "",
    quartier: "",
    adress: "",
    commune: "",
    province: "",
    region: "",
    niveau: "",
    zoom: "",
    speed: 2.5,
  });

  const postHandleSelect = (recherche) => {
    setGeocoding((prevState) => ({
      ...prevState,
      lat: recherche.lat,
      lng: recherche.lng,
      quartier: "",
      adresse: recherche.adresse ? recherche.adresse : recherche._id,
      box: recherche.box ? recherche.box : null,
      adress: recherche.adresse ? recherche.adresse : "",
      commune: recherche.commune ? recherche.commune : "",
      province: recherche.province ? recherche.province : "",
      region: recherche.region ? recherche.region : "",
      niveau: recherche.niveau,
      zoom: recherche.zoom,
      speed: recherche.speed,
    }));
  };

  // testing old functionality

  const handleRechercheLP = async (recherche, transaction_type) => {
    const u = getUrlParams(recherche, transaction_type, prixMax, checked);
    window.open(`/${lang}/list.htm?${u}`);
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleRechercheLP(
          geoCoding,
          props.slug === "louer" ? "Location" : "Vente"
        );
      }}
    >
      <div
        className={`${style.groupFormContainer} ${
          showPlus ? style.containerWithPlus : ""
        }`}
      >
        <div
          className={`${style.forms} ${showPlus ? style.formsWithPlus : ""}`}
          autoFocus
        >
          <div className={style.inputsContainer}>
            <div className={style.autoCompleteContainer}>
              <span className={style.label}>
                {props.SearchBarLpAnnonces.label[lang]}
              </span>
              <div className={style.autoComplete}>
                <PlacesAutocomplete
                  enableMajorZoom={true}
                  enableDefaultSearchList={true}
                  placeholder={props.SearchBarLpAnnonces.placeholder[lang]}
                  postHandleSelect={postHandleSelect}
                  page="landing-page"
                  hide_icon={false}
                  show_icon={false}
                  showSearchIcon={true}
                  lang={lang}
                />
              </div>
            </div>

            <div className={style.budget}>
              <span className={style.label}>
                {props.SearchBarLpAnnonces.BudgetLabel
                  ? props.SearchBarLpAnnonces.BudgetLabel[lang]
                  : ""}
              </span>
              <CustomInput
                type="text"
                pattern="\d*"
                placeHolder={
                  props.SearchBarLpAnnonces.BudgetPlaceholder
                    ? props.SearchBarLpAnnonces.BudgetPlaceholder[lang]
                    : ""
                }
                styleInput={style.input}
                styleContainer={style.inputContainer}
                styleInputFor={style.inputFor}
                value={
                  prixMax
                    ? prixMax.toString().replace(/(.)(?=(\d{3})+$)/g, "$1 ")
                    : ""
                }
                onChange={(e) => {
                  setPrixMax(parseInt(e.target.value.replace(/ /g, "")));
                }}
                name={
                  props.SearchBarLpAnnonces.BudgetPlaceholder
                    ? norm(props.SearchBarLpAnnonces.BudgetPlaceholder[lang])
                    : props.slug
                }
                inputFor={props.slug === t("louer") ? t("DH/MOIS") : t("DH")}
              />
            </div>
            <div className={style.bienTypes}>
              <CheckBox
                text={t("Appartement")}
                value={"Appartement"}
                checked={checked.includes("Appartement")}
                setChecked={setChecked}
              />
              <CheckBox
                text={t("Villa")}
                value={"Villa"}
                checked={checked.includes("Villa")}
                setChecked={setChecked}
              />
              {!showPlus ? (
                <div
                  className={style.plusMinus}
                  onClick={() => {
                    setShowPlus(true);
                  }}
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 1V9M9 9V17M9 9H17M9 9L1 9"
                      stroke="white"
                      stroke-width="1.4"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              ) : (
                <>
                  {" "}
                  {bienImmo.map((item, key) => {
                    return (
                      <CheckBox
                        key={key}
                        text={t(item)}
                        value={item}
                        checked={checked.includes(item)}
                        setChecked={setChecked}
                      />
                    );
                  })}
                </>
              )}
            </div>
          </div>

          <div
            className={style.rechercheBtn}
            data-tracking="click"
            data-value=""
          >
            <Button
              text={props.SearchBarLpAnnonces.button_text[lang]}
              icon={true}
              onClick={(e) => {
                e.preventDefault();
                handleRechercheLP(
                  geoCoding,
                  props.slug === "louer" ? "Location" : "Vente"
                );
              }}
            />
          </div>
        </div>
      </div>
    </form>
  );
}

export default index;
